import React from 'react';
import {videoList} from '../../music list/music';
import './Album.css';

function Album() {
  return (
    <div className="album">
      <div className="release__grid">
        {videoList.map((music) => (
          <article className="album-item container">
            <a
              href={music.redirectedUrl}
              title={music.title}
              className="video__link"
            >
              <img
                src={music.imgSrc}
                alt={music.title}
                className="img-responsive video-thumb"
              />

              <div className="album-overlay">
                <div className="album-info">
                  <h2 className="album-title">{music.title}</h2>
                  <img
                    src={process.env.PUBLIC_URL + '/images/music-more.png'}
                    className="album-play"
                    alt="Play"
                    style={{width: '30px', height: '30px'}}
                  />
                </div>
              </div>
            </a>
          </article>
        ))}
      </div>
    </div>
  );
}

export default Album;
